import { type Entry, TrackEventCategory } from './interface'
import { trackEvent } from './utils'

export default class Exposure {
  private observer: IntersectionObserver | null

  constructor() {
    this.observer = null
    this.init()
  }

  init() {
    // 实例化监听
    this.observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          // 出现在视窗内
          if (entry.isIntersecting) {
            // 获取元素上存储的埋点数据
            const target = entry.target as HTMLElement & { _trackData?: Entry['value'] }
            if (target._trackData) {
              const { action = 'exposure', name, value } = target._trackData
              // console.log(`🚀 埋点触发 - 事件类型:${TrackEventCategory.Exposure}, 事件行为:${action}, 事件名称:${name || '-'}, 事件值:${value || '-'}`)
              trackEvent(TrackEventCategory.Exposure, { action, name, value })
              // 曝光之后取消观察
              this.observer?.unobserve(entry.target)
            }
          }
        })
      },
      {
        root: null,
        rootMargin: '0px',
        threshold: 0.5, // 元素出现面积，0 - 1，这里当元素出现一半以上则进行曝光
      },
    )
  }

  /**
   * 元素添加监听
   */
  add(entry: Entry): void {
    if (this.observer) {
      // 在元素上存储埋点数据
      const target = entry.el as HTMLElement & { _trackData?: Entry['value'] }
      target._trackData = entry.value
      this.observer.observe(entry.el)
    }
  }
}
